import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MainComponent } from './main.component';
import { NavigationModule } from '../common/components/navigation/navigation.module';
import { FooterModule } from '../common/components/footer/footer.module';
@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NavigationModule,
    FooterModule
  ],
  exports: [MainComponent]
})
export class MainModule {}
